import { AbstractDTO } from './abstract';

export class SEODTO extends AbstractDTO {
    title: string;
    description: string;
    no_index: boolean;

    constructor(attributes?: Object) {
        attributes = attributes ? attributes : {};
        super(attributes);

        this.title = attributes['Seo_Title'] || '';
        this.description = attributes['Seo_Description'] || '';
        this.no_index = attributes['no_index'] == "1" ? true : false;
    }

}
